import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import GroupsAccountsTableCell from './GroupsAccountsTableCell';

const EmployeeAccountsRows = ({ headerRows, data }) => {
  //console.log(JSON.stringify(data));

  if (!headerRows || !data) {
    return null;
  }

  return (
    data &&
    data.map((hq, hqIndex) => {
      return hq?.children.map((dp, dpIndex) => {
        return dp?.children.map((emp, empIndex) => {
          return (
            <TableRow key={empIndex}>
              {dpIndex === 0 && empIndex === 0 && emp.id !== 'total' && (
                <TableCell rowSpan={hq.rowSpan} sx={{ width: '130px' }}>
                  {hq.name}
                </TableCell>
              )}
              {empIndex === 0 && emp.id !== 'total' && (
                <TableCell rowSpan={dp.rowSpan} sx={{ width: '130px' }}>
                  {dp.name}
                </TableCell>
              )}
              <TableCell
                sx={{ width: '110px' }}
                align={emp.id === 'total' ? 'right' : 'left'}
                colSpan={emp.id === 'total' ? 3 : 1}
              >
                {emp.name}
              </TableCell>
              <GroupsAccountsTableCell headerRows={headerRows} data={emp} />
            </TableRow>
          );
        });
      });
    })
  );
};

export default EmployeeAccountsRows;
